import { Helmet } from "react-helmet";
import NavbarProgram from "../../components/NavbarProgram";
import { googleFormEnglish } from "../../constant";
import PaymentSection from "../../components/paymentSection";
import { programData, ProgramType } from "../../data/programData";
import ServiceProcess from "../../components/serviceProcess";

const features = [
  {
    title: "Academic Motivation & Narrative Design",
    description:
      "A structured redesign of your academic motivation, experiences, and goals to match top UK university expectations.",
  },
  {
    title: "Logical Flow & Paragraph Analysis",
    description:
      "Detailed evaluation of each paragraph to strengthen the academic storyline and ensure coherent progression.",
  },
  {
    title: "UK-style Tone, Structure & Expression",
    description:
      "Transform your writing into a clear, analytical, and academically aligned UK Personal Statement style.",
  },
  {
    title: "Academic Experience Reframing",
    description:
      "Reconstruct your experiences using UK academic conventions to highlight intellectual readiness and research focus.",
  },
  {
    title: "Comprehensive A3 Feedback Report",
    description:
      "Receive a multi-page analytical report summarising key strengths, structural improvements, and future academic positioning.",
  },
];

const PersonalStatement: React.FC = () => {
  const program = programData.find((p) => p.id === ProgramType.PersonalStatement)!;

  return (
    <div className="flex flex-col min-h-screen">
      <Helmet>
        <title>BeMe – UK Personal Statement Consulting</title>
        <meta
          name="description"
          content="BeMe UK Personal Statement consulting: expert narrative design, academic positioning, and UK-style optimisation for university/graduate admissions."
        />
      </Helmet>

      <NavbarProgram />

      <section className="bg-main text-white py-20 px-4 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
          Personal Statement Consulting
        </h1>
        <p className="max-w-2xl mx-auto text-lg md:text-xl text-sub/90 mb-8">
          Academic narrative consulting designed to make your Personal Statement stand out among
          hundreds of applications.
        </p>

        <a
          href={googleFormEnglish}
          className="inline-block bg-accent text-white px-8 py-3 rounded-lg font-semibold shadow-md hover:bg-yellow-600 transition-colors"
        >
          Get Started
        </a>
      </section>

      {/* <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-main mb-8">Who Is This For?</h2>
          <ul className="text-gray-700 text-lg space-y-4">
            <li>• Applicants preparing for UK university or postgraduate admission</li>
            <li>• Those who want to effectively connect their experiences with academic motivation</li>
            <li>• Applicants seeking a Personal Statement aligned with UK-style structure and expression</li>
          </ul>
        </div>
      </section> */}

      {/* Features Section */}
      <section className="py-16 bg-sub">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-main text-center mb-12">What You Get</h2>
          <div className="grid md:grid-cols-2 gap-10">
            {features.map((feature, idx) => (
              <div
                key={idx}
                className="bg-white p-6 rounded shadow-md hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-semibold text-main mb-2">{feature.title}</h3>
                <p className="text-gray-700">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-20 px-4 text-center">
        <ServiceProcess label={program.label} />
      </section>

      <section className="bg-sub py-20 px-4 text-center">
        <PaymentSection program={program} />
      </section>
    </div>
  );
};

export default PersonalStatement;
